import { sanitiseUrlForEnvironment, trimTrailingSlash, useTenant } from '@parcel2go/npm-p2g-app';
import { useCallback } from 'react';
import { Parcel2GoProvider, RoyalMailProvider, SmartSendProvider } from '~/lib/consts/providers';
import { TenantSettingKeys } from '~/lib/consts/tenant-setting-keys';

export function useServiceLogo() {
  const { settings, theme } = useTenant();

  const getSrc = useCallback(
    (service: { Provider: string; Id: string | null }) => {
      switch (service?.Provider?.toUpperCase()) {
        case Parcel2GoProvider:
        case SmartSendProvider: {
          if (service.Id) {
            const logoRoot = trimTrailingSlash(settings[TenantSettingKeys.BaseURL] || theme?.p2g?.websiteRoot);
            return sanitiseUrlForEnvironment(`${logoRoot}/api/uis/v5/logo/service-logo?slug=${service.Id}`);
          }
          return theme.p2g.smallLogo || '/theme/smartsend/providers/p2g.svg';
        }

        case RoyalMailProvider:
          return 'https://content.parcelsolutions.net/42c5534b-0f47-4342-80f0-8f21203f0669/integrations/courier/rmoba.svg?v=1';

        default:
          return theme.p2g.smallLogo || '/theme/smartsend/providers/p2g.svg';
      }
    },
    [settings, theme]
  );

  const getCourierSrc = useCallback(
    (courierId: string) => {
      if (!courierId) {
        return null;
      }
      const logoRoot = trimTrailingSlash(settings[TenantSettingKeys.BaseURL] || theme?.p2g?.websiteRoot);
      return sanitiseUrlForEnvironment(`${logoRoot}/api/uis/asset-fetcher?title=${courierId}`);
    },
    [settings, theme]
  );

  return { getSrc, getCourierSrc } as const;
}
